import * as React from 'react'
import historyStore from '../../../store/historyStore.ts'
import controlStore from '../../../store/controlStore.ts'

export const HistoryToggles: React.FC = () => {
    const showSafeZones = historyStore(s => s.showSafeZones)
    const includeInvalid = historyStore(s => s.includeInvalid)
    const isMobile = controlStore(s => s.isOnMobileDevice)

    const paddingTop = isMobile ? 'pt-[3px]' : 'pt-[5px]'

    return (
        <div className={'flex items-center gap-2'}>
            <button
                className={`btn btn-xs ${showSafeZones ? 'btn-primary' : 'btn-outline btn-primary'} ${paddingTop}`}
                onClick={() => historyStore.getState().setShowSafeZones(!showSafeZones)}
            >
                Safe Zones
            </button>
            {!isMobile && (
                <button
                    className={`btn btn-xs ${!includeInvalid ? 'btn-primary' : 'btn-outline btn-primary'} ${paddingTop}`}
                    onClick={() => historyStore.getState().setIncludeInvalid(!includeInvalid)}
                >
                    Valid GPS Only
                </button>
            )}
        </div>
    )
}
